<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="80px"
				:rules="rules">

				<el-row>
					<el-col :span="24">
						<el-form-item label="Sprint:" prop="snm" style="font-weight: bold;"
							v-if="parameter.snm != null">
							{{ parameter.snm }}
						</el-form-item>
						<el-form-item label="Sprint:" prop="snm" style="color:#0099FF ;"
							v-else-if="parameter.snm == null">
							未分配<b>Sprint</b>，请到<b>Sprint</b>列表选择<b>Sprint</b>添加该团队
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="团队名称:" prop="name">
							{{ formParameter.name }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="负责人:" prop="header">
							{{ formParameter.header }}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="parameter.pname">
					<el-col :span="24">
						<el-form-item label="产品名称:" prop="header">
							【{{ parameter.pname }}】
							<span v-if="parameter.sprints" v-for="(v, i) in parameter.sprints">{{ v.nm }}
								<span v-if="i < (parameter.sprints.length - 1)">、</span> </span>

						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-table :data="teamMember" style="width: 100%;">
							<el-table-column prop="uid" label="名字" width="130">
							</el-table-column>
							<el-table-column prop="post" label="角色" width="110">
								<template slot-scope="scope">
									<el-tag
										:type="scope.row.post == 'SM' ? 'danger' : (scope.row.post == 'PO' ? 'primary' : 'success')">
										{{ scope.row.post }}
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="starttime" label="开始时间">
							</el-table-column>
							<el-table-column prop="endtime" label="结束时间">
							</el-table-column>
							<el-table-column prop="hour4day" label="工时/日" width="85">
							</el-table-column>
							<el-table-column prop="did" label="部门" width="150">
							</el-table-column>
							<el-table-column prop="sex" label="性别" width="85">
							</el-table-column>
							<el-table-column prop="mobile" label="电话">
							</el-table-column>
						</el-table>
					</el-col>

				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button @click="close">关 闭</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/team/team/team.js';
import apiDpt from '@/api/system/department/department.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';



export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
	},
	data() {
		return {
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},  //team
			teamMember: [],	     //team成员  [{},{}..]

			rules: {}
		};
	},
	methods: {

		//打开弹框
		open(parameter, title) {
			this.parameter = parameter;

			//console.log("传过来的数据",this.parameter);



			this.$refs.popup.open(title, "1000px");
			this.$nextTick(() => {
				this.formParameter = {};
				this.formParameter.name = this.parameter.teamname;
				this.formParameter.pname = this.parameter.pname;
				this.teamMember = [];
				//清楚校验
				//this.$refs.form.clearValidate();
				//编辑查询数据
				let parameter;
				if (this.parameter.sid) {
					parameter = { id: this.parameter.sid }
				} else {
					parameter = { tid: this.parameter.tid }
				}

				api.toUpdate(parameter, response => {
					//team
					// this.popupLoading = false;

					//this.formParameter.name = response.data.teamInfo.name;
					this.formParameter.header = response.data[0].name;


					//teamMember
					for (let idx = 0; idx < response.data.length; idx++) {
						this.teamMember.push({
							did: response.data[idx].dept,
							post: response.data[idx].post,
							uid: response.data[idx].name,
							hour4day: response.data[idx].hour4day,
							starttime: response.data[idx].starttime,
							endtime: response.data[idx].endtime,
							sex: response.data[idx].sex == 1 ? "男" : "女",
							mobile: response.data[idx].mobile,
						})
					}
				}


				);
			})
		},
		//关闭弹框
		close() {
			//刷新一下页面
			this.$refs.popup.close();
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
